export default "__VITE_ASSET__2c76a4d9__"